import React, { ReactElement } from "react";
import { Container } from "react-bootstrap";
function ButtonLoader(): ReactElement {
  return (
    <Container fluid>
      <div>
        <img src="./imgs/785.gif" style={{ width: "20px" }} alt=""></img>
      </div>
    </Container>
  );
}

export default ButtonLoader;
